import React from 'react';
import {FEATURE_FLAGS} from "../../services/feature_flags";

export default function ChartPane() {
    function getStyle() {
        if (FEATURE_FLAGS.TABLE_MENU_SIDE) {
            return {'marginLeft': 30};
        }
    }
    return (
        <div className="chart-pane" style={getStyle()}>
            <div className="chart-placeholder-container">
                <div className="placeholder-content">
                    <img src="/images/chart-placeholder.svg" alt="" />
                    <div className="pipeline-step-text placeholder-text">
                        Select columns on the left to build a table.<br />
                        The chart preview is disabled in this prototype.
                    </div>
                </div>
            </div>
            {/*<div className="chart-type-panel disabled w-clearfix">*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Table.svg" width="16" height="16" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Number_1.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Number-with-indicator.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Bullet.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Pie.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Area.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Line.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Bar.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Bar-Line.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Box-Plot.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Scatter.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Bubble.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Map.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Bubble-Map.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Funnel.svg" alt="" />*/}
                {/*</div>*/}
                {/*<div className="chart-type-icon-wrapper">*/}
                    {/*<img src="/images/Heat-map.svg" alt="" />*/}
                {/*</div>*/}
            {/*</div>*/}
        </div>
    );
}
